function findDetailMachineRef(details: any, nameToMatch: any) {
  const detail = details.find((detail: any) => detail.name === nameToMatch);
  if (!detail) return undefined;
  return detail.machineRef;
}

export { findDetailMachineRef };
